import * as Yup from 'common/yup';
import {defaultPortSchema} from 'common/yup/customs/portSchema';
import i18n from '../i18n';
import {diplomatObjectSchema} from './diplomat-object';

export const ftpSettingsSchema = diplomatObjectSchema.shape({
   useDefaultActiveIpAddress: Yup.boolean(),
   activeIpAddress: Yup.string().when('useDefaultActiveIpAddress', {
      is: false,
      then: Yup.string()
         .matches(/\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b/, {message: i18n.t('Invalid IP Address')})
         .required(i18n.t('Required')),
   }),
   useDefaultActivePorts: Yup.boolean(),
   startPort: Yup.number().when('useDefaultActivePorts', {
      is: false,
      then: defaultPortSchema().required(i18n.t('Required')),
   }),
   endPort: Yup.number().when('useDefaultActivePorts', {
      is: false,
      then: defaultPortSchema()
         .min(Yup.ref('startPort'), i18n.t('End port cannot be less than start port'))
         .required(i18n.t('Required')),
   }),
   internalPartner: Yup.boolean(),
   outboundTransaction: Yup.boolean(),
   inboundTransaction: Yup.boolean(),
   externalPartner: Yup.boolean(),
   sslClientCert: Yup.boolean(),
   sslServerCert: Yup.boolean(),
   proxyServer: Yup.boolean(),
   key: Yup.boolean(),
   calendar: Yup.boolean(),
   partner: Yup.boolean(),
   user: Yup.boolean(),
   transaction: Yup.boolean(),
   sshKey: Yup.boolean(),
   folder: Yup.boolean(),
   secretKey: Yup.boolean(),
   sslCert: Yup.boolean(),
   publicKey: Yup.boolean(),
   valid: Yup.boolean(),
   lastUpdateText: Yup.string(),
});

export type FTPSettings = Yup.InferType<typeof ftpSettingsSchema>;
